(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se2-announcement"] && !Shopify.designMode) return;
  try {
    
  /* SE2 · Announcement band. Rotates the messages on a timer, with a visible pause / play control and holds
     while a pointer is over the band, while a message link has focus, while the tab is hidden and while a
     block is selected in the theme editor. The pause choice lives in sessionStorage for the visit.
     Reduced motion starts the band paused; Play is the visitor's explicit opt-in and always restarts
     rotation, clearing any hover or focus hold the click itself created. */
  (() => {
    if (window.customElements.get('se2-announcement')) return;

    const STORE_KEY = 'se2-ann-paused';
    const reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    // Storage throws when it is blocked (private windows, embedded previews); the band must still run.
    const readChoice = () => {
      try {
        return window.sessionStorage.getItem(STORE_KEY);
      } catch (_) {
        return null;
      }
    };
    const writeChoice = (value) => {
      try {
        window.sessionStorage.setItem(STORE_KEY, value);
      } catch (_) {
        /* nothing to do: the choice simply does not outlive the page */
      }
    };

    class Se2Announcement extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-se2-ann-slide]'));
        this.toggle = this.querySelector('[data-se2-ann-toggle]');
        this.timer = null;
        this.index = 0;
        this.hovering = false;
        this.focused = false;
        this.editing = false;
        if (this.slides.length < 2) return;

        const seconds = parseInt(this.dataset.interval, 10);
        this.interval = Math.min(10, Math.max(4, Number.isFinite(seconds) ? seconds : 6)) * 1000;

        const choice = readChoice();
        this.paused = choice === '1' || (choice !== '0' && Boolean(reduced && reduced.matches));

        this.setAttribute('data-ready', '');
        this.show(0);

        // Every listener hangs off one controller so a reconnect (the editor moving the section, any
        // DOM move) cannot stack a second click handler on the toggle and flip the state twice per press.
        this.abort = new AbortController();
        const { signal } = this.abort;

        if (this.toggle) {
          this.toggle.hidden = false;
          this.toggle.addEventListener('click', this.onToggle, { signal });
          this.paint();
        }

        this.addEventListener('pointerenter', this.onPointerEnter, { signal });
        this.addEventListener('pointerleave', this.onPointerLeave, { signal });
        this.addEventListener('focusin', this.onFocusIn, { signal });
        this.addEventListener('focusout', this.onFocusOut, { signal });
        document.addEventListener('visibilitychange', this.onVisibility, { signal });
        document.addEventListener('shopify:block:select', this.onBlockSelect, { signal });
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect, { signal });
        if (reduced) reduced.addEventListener('change', this.onMotionChange, { signal });

        this.schedule();
      }

      disconnectedCallback() {
        this.stop();
        if (this.abort) this.abort.abort();
      }

      get held() {
        return this.hovering || this.focused || this.editing;
      }

      show(index) {
        this.index = index;
        this.slides.forEach((slide, i) => {
          const off = i !== index;
          slide.toggleAttribute('inert', off);
          if (off) {
            slide.setAttribute('aria-hidden', 'true');
          } else {
            slide.removeAttribute('aria-hidden');
          }
        });
      }

      /* One timeout at a time. Every tick re-checks the holds, so a hold that arrives mid-interval simply
         stops the next advance rather than needing its own bookkeeping. */
      schedule() {
        this.stop();
        if (this.paused || this.held || document.hidden) return;
        this.timer = window.setTimeout(() => {
          this.timer = null;
          this.show((this.index + 1) % this.slides.length);
          this.schedule();
        }, this.interval);
      }

      stop() {
        if (this.timer !== null) {
          window.clearTimeout(this.timer);
          this.timer = null;
        }
      }

      paint() {
        if (!this.toggle) return;
        this.toggle.dataset.state = this.paused ? 'paused' : 'playing';
        const label = this.paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause;
        if (label) this.toggle.setAttribute('aria-label', label);
      }

      onToggle = () => {
        this.paused = !this.paused;
        writeChoice(this.paused ? '1' : '0');
        if (!this.paused) {
          /* The click leaves the pointer over the band and focus on the button. Neither may keep an
             explicit Play from rotating, so both holds are released here and re-arm on the next enter. */
          this.hovering = false;
          this.focused = false;
        }
        this.paint();
        this.schedule();
      };

      onPointerEnter = () => {
        this.hovering = true;
        this.stop();
      };

      onPointerLeave = () => {
        this.hovering = false;
        this.schedule();
      };

      /* Only a message link holds rotation on focus; focus on the pause / play button must not, or Play
         could never take effect from the keyboard. */
      onFocusIn = (event) => {
        if (!(event.target instanceof Element) || !event.target.closest('[data-se2-ann-slide]')) return;
        this.focused = true;
        this.stop();
      };

      onFocusOut = (event) => {
        const next = event.relatedTarget;
        if (next instanceof Element && next.closest('[data-se2-ann-slide]') && this.contains(next)) return;
        this.focused = false;
        this.schedule();
      };

      onVisibility = () => {
        if (document.hidden) {
          this.stop();
        } else {
          this.schedule();
        }
      };

      onMotionChange = (event) => {
        if (!event.matches || readChoice() === '0') return;
        this.paused = true;
        this.paint();
        this.stop();
      };

      onBlockSelect = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const index = this.slides.findIndex((slide) => slide === target || (target && slide.contains(target)));
        if (index < 0) return;
        this.editing = true;
        this.stop();
        this.show(index);
      };

      onBlockDeselect = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (target && !this.contains(target)) return;
        this.editing = false;
        this.schedule();
      };
    }

    window.customElements.define('se2-announcement', Se2Announcement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se2-cold-air"] && !Shopify.designMode) return;
  try {
    
  /* SE2 · Cold-air guide: repaint the fills list when the main product's Size radio changes. No fetch; the
     list already holds every tank size in data-cap, so the new bottle size is all the arithmetic needs. */
  (() => {
    const html = document.documentElement;
    if (html.dataset.se2CagBound === '1') return;
    html.dataset.se2CagBound = '1';

    /* "20 mL" and "20mL" both give 20; anything without "mL" (a "Default Title" variant) gives 0 and is skipped. */
    const parseMl = (value) => {
      const text = String(value || '');
      if (!/ml/i.test(text)) return 0;
      const n = parseFloat(text);
      return Number.isFinite(n) && n > 0 ? n : 0;
    };

    /* "a, b and c" */
    const list = (items) => {
      if (items.length <= 1) return items.join('');
      return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
    };

    /* The pill words are the merchant's own labels (data-label-*), the same strings Liquid printed. The trial
       label, when set, replaces the top-up word only while the product's smallest size is selected. */
    const pillText = (root, n, ml) => {
      if (n >= 2) return (root.dataset.labelFills || '{count} fills').replace('{count}', String(n));
      if (n === 1) return root.dataset.labelFill || '1 fill';
      const trial = parseFloat(root.dataset.trialMl || '');
      if (root.dataset.labelTopupTrial && Number.isFinite(trial) && trial > 0 && ml <= trial) {
        return root.dataset.labelTopupTrial;
      }
      return root.dataset.labelTopup || 'Top-up';
    };

    /* One sentence for the live region in the words already on screen: the size line, then each distinct pill
       with the diffusers that share it, in row order ("Your 50 mL bottle fills: SCENTPRO Mini, 5 fills;
       SCENTPRO One, ... and SCENTPRO Max, Top-up."). Grouping keeps seven rows from reading as seven lines,
       and because the words come from the labels, a renamed pill is announced under its new name. */
    const sentence = (sizeText, rows) => {
      const groups = [];
      rows.forEach(({ name, pill }) => {
        const group = groups.find((g) => g.pill === pill);
        if (group) group.names.push(name);
        else groups.push({ pill, names: [name] });
      });
      const lead = /[:;,.!?]$/.test(sizeText) ? sizeText : `${sizeText}:`;
      return `${lead} ${groups.map((g) => `${list(g.names)}, ${g.pill}`).join('; ')}.`;
    };

    const paint = (root, ml) => {
      const rows = [];
      root.querySelectorAll('[data-se2-cag-row]').forEach((row) => {
        const cap = parseFloat(row.dataset.cap || '');
        if (!Number.isFinite(cap) || cap <= 0) return;
        const n = Math.floor(ml / cap);
        const text = pillText(root, n, ml);
        const pill = row.querySelector('[data-se2-cag-pill]');
        const nameEl = row.querySelector('[data-se2-cag-name]');
        if (pill) {
          pill.textContent = text;
          pill.classList.toggle('is-fill', n >= 1);
        }
        rows.push({ name: nameEl ? nameEl.textContent.trim() : '', pill: text });
      });
      const sizeText = (root.dataset.sizeLine || 'Your {size} bottle fills:').replace('{size}', `${ml} mL`);
      const size = root.querySelector('[data-se2-cag-size]');
      if (size) size.textContent = sizeText;

      /* Below Guide From Size the table folds away and the tiles stand alone; with no tiles the band folds
         too. In the editor the band stays and the note explains the empty box instead. */
      const min = parseFloat(root.dataset.minMl || '') || 0;
      const below = ml < min;
      const guide = root.querySelector('[data-se2-cag-guide]');
      if (guide) guide.hidden = below;
      const note = root.querySelector('[data-se2-cag-min-note]');
      if (note) note.hidden = !below;
      const editor = Boolean(window.Shopify && window.Shopify.designMode);
      if (!editor) root.hidden = below && !root.querySelector('[data-se2-cag-claims]');

      const live = root.querySelector('[data-se2-cag-live]');
      if (live && rows.length) live.textContent = below ? '' : sentence(sizeText, rows);
    };

    /* Scoped the way assets/variant-picker.js scopes its own page test: the picker must be the template
       product's (data-template-product-match), and not a card or quick-add picker. A root only follows a
       picker for its own product, and a root rendered for a diffuser has no bottle and is left alone. */
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
      if ((input.dataset.optionName || '').trim().toLowerCase() !== 'size') return;
      if (input.closest('product-card, quick-add-dialog')) return;
      const picker = input.closest('variant-picker');
      if (!picker || picker.dataset.templateProductMatch !== 'true') return;
      const ml = parseMl(input.value);
      if (!ml) return;
      document.querySelectorAll('[data-se2-cag][data-mode="fragrance"]').forEach((root) => {
        const rootId = root.dataset.productId || '';
        const pickerId = picker.dataset.productId || '';
        if (rootId && pickerId && rootId !== pickerId) return;
        paint(root, ml);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se2-home-diffusers"] && !Shopify.designMode) return;
  try {
    
  /* SE2 · home rail (S-home-06, 2026-10-06; round 1). Previous / next buttons under a phone scroller: the diffuser
     row here and the two feel rows of sections/se2-home-feel.liquid, each a [data-se2-hrail] wrapper holding one
     [data-se2-hrail-track] and its [data-se2-hrail-prev] / [data-se2-hrail-next] buttons. The wrapper is marked
     data-scrollable while the track overflows (the buttons show only then), data-at-start / data-at-end at its ends,
     and the button with nothing left to reveal is aria-disabled, so it is announced as unavailable and a press on it
     does nothing. A press scrolls by one card and the gap. There is no arrow-key handler: keys pressed on a focused
     card keep the browser's own behaviour. Everything is delegated from document (a scroll is caught on its way down,
     since it does not bubble), so a section the theme editor re-renders, or a feel row the toggle has just shown
     (it fires a scroll on that row's track), is read again without re-binding.
     The same block sits in sections/se2-home-feel.liquid, word for word: Shopify runs a section's script only on a
     page that renders that section, so each section that draws a rail carries it, and the window flag lets the first
     copy that runs bind it once for both. Change both together. */
  (() => {
    if (window.se2HomeRailReady) return;
    window.se2HomeRailReady = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const update = (rail) => {
      const track = rail.querySelector('[data-se2-hrail-track]');
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft >= max - 1;
      rail.toggleAttribute('data-scrollable', max > 1);
      rail.toggleAttribute('data-at-start', atStart);
      rail.toggleAttribute('data-at-end', atEnd);
      rail.querySelectorAll('[data-se2-hrail-prev]').forEach((b) => b.setAttribute('aria-disabled', String(atStart)));
      rail.querySelectorAll('[data-se2-hrail-next]').forEach((b) => b.setAttribute('aria-disabled', String(atEnd)));
    };
    const updateAll = () => document.querySelectorAll('[data-se2-hrail]').forEach(update);

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element
        ? event.target.closest('[data-se2-hrail-prev], [data-se2-hrail-next]')
        : null;
      if (!button || button.getAttribute('aria-disabled') === 'true') return;
      const rail = button.closest('[data-se2-hrail]');
      const track = rail ? rail.querySelector('[data-se2-hrail-track]') : null;
      if (!track) return;
      const first = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const amount = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      const direction = button.hasAttribute('data-se2-hrail-next') ? 1 : -1;
      track.scrollBy({ left: amount * direction, behavior: reduced.matches ? 'auto' : 'smooth' });
    });

    document.addEventListener('scroll', (event) => {
      const track = event.target;
      if (!(track instanceof Element) || !track.hasAttribute('data-se2-hrail-track')) return;
      const rail = track.closest('[data-se2-hrail]');
      if (rail) update(rail);
    }, { capture: true, passive: true });

    window.addEventListener('resize', updateAll, { passive: true });
    window.addEventListener('load', updateAll);
    document.addEventListener('shopify:section:load', updateAll);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll);
    } else {
      updateAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se2-home-editorial"] && !Shopify.designMode) return;
  try {
    
  /* SE2 v11 / Lane 7 · homepage hero.
     (a) Overlay header: RETIRED 2026-09-10. initHeader() below only clears [data-se2-overlay] so the superseded rules
         in assets/se2-ethereal.css can never match.
     (b) Playing video (operator, 2026-09-09; pause control 2026-10-06, V-home-02 / WCAG 2.2.2): the markup carries no
         autoplay attribute (V-home-03), so this script starts the clip: play() on init, canplay / loadeddata, on
         visibilitychange (back to visible), on pageshow (bfcache), on window focus and whenever the banner comes back
         into view; one retry on the first user gesture if autoplay was refused (iOS Low Power Mode, data-saver).
         None of these starts it before the poster (the LCP image) has loaded or failed, or window load, so the
         stream never takes a slow link's bandwidth from the poster. The visitor's pause always wins: the toggle
         (sessionStorage 'se2-hero-paused', for the visit), and any pause that lands while any of the banner is on
         screen in a visible tab (OS media keys, another script). Until the visitor presses play again none of the
         hooks above restarts it. Pauses the browser makes on its own (hidden tab) are not the visitor's, so the hooks
         resume the clip as before. The script pauses the clip itself only while the banner is fully off screen, and
         that pause is not the visitor's either, so the toggle keeps offering "Pause the motion".
     (c) 2026-11-04 (batch 5): the toggle is the page's motion control. Whenever the visitor's choice is "paused" the
         script sets [data-se2-motion-paused] on #MainContent, which stops every SE2 motion inside the page content,
         the product cards' notes included (.design/build-2026-11-03/b2-card-contract.md); "Play the motion" clears it
         and the cards replay from their start. A refused autoplay is not the visitor's choice, so it shows the play
         glyph but leaves the cards alone.
     (d) Reduced motion (2026-11-04; was: the video parked and the toggle removed). With respect_reduced_motion on and
         the system asking for less motion, the hero opens still: the poster shows (.se2-vb--still), nothing beyond
         the metadata is fetched, the clip never starts by itself (not even with a stored "playing" choice) and the
         toggle reads "Play the motion". Pressing it is the visitor's own request, so the video then plays. */
  (() => {
    const reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    const STORE_KEY = 'se2-hero-paused';
    const PAUSE_ATTR = 'data-se2-motion-paused';
    const readChoice = () => {
      try { return window.sessionStorage.getItem(STORE_KEY); } catch (e) { return null; }
    };
    const writeChoice = (value) => {
      try { window.sessionStorage.setItem(STORE_KEY, value); } catch (e) { /* storage blocked: the choice lasts this page */ }
    };
    /* The page content, so the header's own announcement band keeps its separate control. */
    const holdPage = (paused) => {
      const root = document.getElementById('MainContent') || document.documentElement;
      root.toggleAttribute(PAUSE_ATTR, paused);
    };

    const initHeader = () => {
      const header = document.getElementById('header-component');
      if (!header) return;
      if (typeof header.se2HeroCleanup === 'function') {
        header.se2HeroCleanup();
        header.se2HeroCleanup = null;
      }
      /* RETIRED (Figma 557:148): never setting the attribute is what stops the old over-hero rules matching. */
      header.removeAttribute('data-se2-overlay');
    };

    const initVideo = (hero) => {
      if (!hero) return;
      if (typeof hero.se2VideoCleanup === 'function') {
        hero.se2VideoCleanup();
        hero.se2VideoCleanup = null;
      }
      const video = hero.querySelector('[data-se2-hero-video]');
      if (!video) return;
      const toggle = hero.querySelector('[data-se2-hero-toggle]');
      const respectReduced = hero.getAttribute('data-se2-respect-reduced-motion') !== 'false';
      let still = respectReduced && reduced.matches;
      hero.classList.toggle('se2-vb--still', still);
      if (still) video.preload = 'none';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.setAttribute('playsinline', '');

      let inView = true;
      /* true between the script's own off-screen pause() and the pause event it fires */
      let selfPause = false;
      let gestureArmed = false;
      let userPaused = still || readChoice() === '1';
      const gestureEvents = ['pointerdown', 'touchstart', 'keydown', 'click'];
      const listeners = [];
      const on = (target, type, fn, opts) => {
        target.addEventListener(type, fn, opts);
        listeners.push(() => target.removeEventListener(type, fn, opts));
      };

      /* The visitor's choice drives the page hold; the glyph and name follow what a press would do. */
      const setUserPaused = (paused) => {
        userPaused = paused;
        holdPage(paused);
      };
      const paint = (paused) => {
        if (!toggle) return;
        toggle.dataset.state = paused ? 'paused' : 'playing';
        const label = paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause;
        if (label) toggle.setAttribute('aria-label', label);
      };

      /* V-home-03, round 1: the poster is the page's LCP image, so the clip waits for it. */
      const posterImg = hero.querySelector('.se2-vb__poster-img');
      let mediaReady = !posterImg || posterImg.complete;

      const play = () => {
        if (!mediaReady || userPaused || !inView || !video.paused || document.visibilityState === 'hidden') return;
        let promise;
        try { promise = video.play(); } catch (e) { promise = null; }
        if (promise && typeof promise.catch === 'function') {
          promise.catch(() => {
            /* Off screen this is the script's own pause() cutting a start short (AbortError), not a refusal. */
            if (!inView) return;
            /* autoplay refused: the toggle shows play, and the first user gesture retries once, unless the visitor
               has asked to save data (audit HOME-M-05). A gesture on the toggle is left to the toggle. */
            paint(true);
            if (gestureArmed) return;
            if (navigator.connection && navigator.connection.saveData) return;
            gestureArmed = true;
            const retry = (event) => {
              if (toggle && event && event.target instanceof Node && toggle.contains(event.target)) return;
              play();
            };
            gestureEvents.forEach((type) => on(window, type, retry, { once: true, passive: true, capture: true }));
          });
        }
      };

      if (!mediaReady) {
        const ready = () => {
          if (mediaReady) return;
          mediaReady = true;
          if (inView) play();
        };
        on(posterImg, 'load', ready, { once: true });
        on(posterImg, 'error', ready, { once: true });
        on(window, 'load', ready, { once: true });
      }

      /* 634:6 progress fill, scaled off the clip's own currentTime. */
      const progress = hero.querySelector('[data-se2-hero-progress]');
      if (progress) {
        const fill = () => {
          const total = video.duration;
          if (!total || !isFinite(total) || total <= 0) return;
          const ratio = Math.min(Math.max(video.currentTime / total, 0), 1);
          progress.style.width = (ratio * 100).toFixed(3) + '%';
        };
        ['timeupdate', 'seeked', 'loadedmetadata', 'durationchange'].forEach((type) => on(video, type, fill));
        on(video, 'ended', () => { progress.style.width = '0%'; });
        fill();
      }

      const onScreen = () => {
        const r = hero.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        return r.bottom > 0 && r.top < vh && r.height > 0;
      };

      ['canplay', 'loadeddata', 'loadedmetadata'].forEach((type) => on(video, type, play));
      on(video, 'playing', () => {
        /* playing again, whoever started it (the toggle, OS media keys): the visitor's pause is over */
        setUserPaused(false);
        if (readChoice() === '1') writeChoice('0');
        paint(false);
      });
      on(video, 'pause', () => {
        if (selfPause) {
          selfPause = false;
          return;
        }
        /* A pause while any of the banner is on screen in a visible tab is the visitor's (OS media keys). */
        if (!video.ended && document.visibilityState === 'visible' && onScreen()) setUserPaused(true);
        paint(true);
      });
      on(video, 'error', () => hero.classList.add('se2-vb--video-failed'), true);
      on(document, 'visibilitychange', () => {
        if (document.visibilityState === 'visible' && inView) play();
      });
      on(window, 'pageshow', play);
      on(window, 'focus', () => {
        if (inView) play();
      });

      if (toggle) {
        /* The press follows what the toggle shows, not video.paused: before the poster is in, the clip is about to
           play and the toggle offers "Pause the motion", which must hold it. An explicit play needs no poster wait,
           and in the reduced-motion still state it is the visitor asking for the video, so the still lifts. */
        on(toggle, 'click', () => {
          if (toggle.dataset.state === 'paused') {
            if (still) {
              still = false;
              hero.classList.remove('se2-vb--still');
              video.preload = 'auto';
            }
            setUserPaused(false);
            mediaReady = true;
            writeChoice('0');
            paint(false);
            play();
          } else {
            setUserPaused(true);
            writeChoice('1');
            paint(true);
            if (!video.paused) video.pause();
          }
        });
        paint(userPaused);
        toggle.hidden = false;
      }
      holdPage(userPaused);

      let observer = null;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            inView = entry.isIntersecting;
            if (entry.isIntersecting) {
              play();
            } else if (!video.paused) {
              /* fully off screen: hold the clip so it stops decoding and streaming while nobody can see it */
              selfPause = true;
              video.pause();
            }
          });
        }, { threshold: 0 });
        observer.observe(hero);
      }

      hero.se2VideoCleanup = () => {
        listeners.forEach((off) => off());
        if (observer) observer.disconnect();
      };

      play();
    };

    const init = () => {
      const hero = document.querySelector('.se2-home--video_banner [data-se2-hero]');
      initHeader();
      initVideo(hero);
    };
    init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se2-home-feel"] && !Shopify.designMode) return;
  try {
    
  /* SE2 · home "Shop by" toggle. The server already shows the starting group and presses its button, so this only
     swaps which row is visible. Delegated from document, so a section the theme editor re-renders keeps working
     without re-binding. A row measures as not scrollable while it is hidden, so the one just shown gets a scroll
     event: the home rail below re-reads it and shows its buttons if it overflows (S-home-06). */
  (() => {
    const select = (root, group) => {
      root.querySelectorAll('[data-se2-feel-seg]').forEach((seg) => {
        seg.setAttribute('aria-pressed', seg.dataset.se2FeelSeg === group ? 'true' : 'false');
      });
      root.querySelectorAll('[data-se2-feel-row]').forEach((row) => {
        row.hidden = row.dataset.se2FeelRow !== group;
        const track = row.hidden ? null : row.querySelector('[data-se2-hrail-track]');
        if (track) track.dispatchEvent(new Event('scroll'));
      });
    };

    document.addEventListener('click', (event) => {
      const seg = event.target instanceof Element ? event.target.closest('[data-se2-feel-seg]') : null;
      if (!seg || seg.getAttribute('aria-pressed') === 'true') return;
      const root = seg.closest('[data-se2-feel]');
      if (root) select(root, seg.dataset.se2FeelSeg);
    });

    // Theme editor: selecting a card that sits in the hidden group brings that group forward.
    document.addEventListener('shopify:block:select', (event) => {
      const row = event.target instanceof Element ? event.target.closest('[data-se2-feel-row]') : null;
      const root = row ? row.closest('[data-se2-feel]') : null;
      if (row && root && row.hidden) select(root, row.dataset.se2FeelRow);
    });
  })();

  /* SE2 · home rail (S-home-06, round 1): the rail buttons under each feel row. The same block as in
     sections/se2-home-diffusers.liquid, word for word, where it is described: Shopify runs a section's script only on
     a page that renders that section, so this copy keeps the rows working without the diffuser section, and the
     window flag binds the rail once when both are on the page. Change both together. */
  (() => {
    if (window.se2HomeRailReady) return;
    window.se2HomeRailReady = true;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const update = (rail) => {
      const track = rail.querySelector('[data-se2-hrail-track]');
      if (!track) return;
      const max = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft >= max - 1;
      rail.toggleAttribute('data-scrollable', max > 1);
      rail.toggleAttribute('data-at-start', atStart);
      rail.toggleAttribute('data-at-end', atEnd);
      rail.querySelectorAll('[data-se2-hrail-prev]').forEach((b) => b.setAttribute('aria-disabled', String(atStart)));
      rail.querySelectorAll('[data-se2-hrail-next]').forEach((b) => b.setAttribute('aria-disabled', String(atEnd)));
    };
    const updateAll = () => document.querySelectorAll('[data-se2-hrail]').forEach(update);

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element
        ? event.target.closest('[data-se2-hrail-prev], [data-se2-hrail-next]')
        : null;
      if (!button || button.getAttribute('aria-disabled') === 'true') return;
      const rail = button.closest('[data-se2-hrail]');
      const track = rail ? rail.querySelector('[data-se2-hrail-track]') : null;
      if (!track) return;
      const first = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const amount = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      const direction = button.hasAttribute('data-se2-hrail-next') ? 1 : -1;
      track.scrollBy({ left: amount * direction, behavior: reduced.matches ? 'auto' : 'smooth' });
    });

    document.addEventListener('scroll', (event) => {
      const track = event.target;
      if (!(track instanceof Element) || !track.hasAttribute('data-se2-hrail-track')) return;
      const rail = track.closest('[data-se2-hrail]');
      if (rail) update(rail);
    }, { capture: true, passive: true });

    window.addEventListener('resize', updateAll, { passive: true });
    window.addEventListener('load', updateAll);
    document.addEventListener('shopify:section:load', updateAll);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll);
    } else {
      updateAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se2-home-tabs"] && !Shopify.designMode) return;
  try {
    
  /* SE2 · Lane 9 · tabs: roving tabindex, arrow keys, panels and "View all" follow the selected tab. */
  (() => {
    const init = (root) => {
      if (!root || root.dataset.se2TabsReady === '1') return;
      const tabs = Array.from(root.querySelectorAll('[data-se2-tab]'));
      if (tabs.length < 2) return;
      root.dataset.se2TabsReady = '1';
      const panels = Array.from(root.querySelectorAll('[data-se2-panel]'));
      const links = Array.from(root.querySelectorAll('[data-se2-tab-link]'));
      const select = (key, focus) => {
        tabs.forEach((tab) => {
          const on = tab.dataset.se2Tab === key;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.se2Panel !== key; });
        links.forEach((link) => { link.hidden = link.dataset.se2TabLink !== key; });
      };
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => select(tab.dataset.se2Tab, false));
        tab.addEventListener('keydown', (event) => {
          const index = tabs.indexOf(tab);
          let next = null;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          select(tabs[next].dataset.se2Tab, true);
        });
      });
    };
    document.querySelectorAll('[data-se2-tabs]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target && event.target.querySelector ? event.target.querySelector('[data-se2-tabs]') : null;
      init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se2-home-tech"] && !Shopify.designMode) return;
  try {
    
  /* SE2 · Lane 9 · technology track: arrow buttons scroll by one card; the buttons only show when the track overflows. */
  (() => {
    const init = (root) => {
      if (!root || root.dataset.se2TechReady === '1') return;
      const track = root.querySelector('[data-se2-tech-track]');
      if (!track) return;
      root.dataset.se2TechReady = '1';
      const step = () => {
        const card = track.querySelector('.se2-htech__card');
        return card ? card.getBoundingClientRect().width + 8 : track.clientWidth * 0.8;
      };
      const paint = () => {
        const overflow = track.scrollWidth - track.clientWidth > 4;
        root.toggleAttribute('data-scrollable', overflow);
        root.toggleAttribute('data-at-start', track.scrollLeft <= 2);
        root.toggleAttribute('data-at-end', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
      };
      const prev = root.querySelector('[data-se2-tech-prev]');
      const next = root.querySelector('[data-se2-tech-next]');
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint, { passive: true });
      paint();
    };
    document.querySelectorAll('[data-se2-tech]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target && event.target.querySelector ? event.target.querySelector('[data-se2-tech]') : null;
      init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
